export default __webpack_public_path__ + "static/media/challenge.6e46f13f.wav";